import React from 'react';
import SportCardHeader from '../../../sport/card/header/SportCardHeader';
import { FoComboCardWithOdds } from '@staycool/sports-types/fo-combo-card';
import SportCategoryIcon from '../../../sport/category-icon/SportCategoryIcon';

interface Props {
    card: FoComboCardWithOdds;
}

export default function ComboCardsItemHeader({ card }: Props) {
    const { betting_end, matches, type, name } = card;
    const numberOfOutcomes = matches.reduce((acc, match) => acc + match.markets.length, 0);

    return (
        <SportCardHeader
            type={type}
            numberOfOutcomes={numberOfOutcomes}
            bettingEnd={betting_end.toString()}
            title={name}
            icon={<SportCategoryIcon icon={`${card.matches[0]?.sport_name}`} />}
        />
    );
}
